import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-product-content _mt-3"
}
const _hoisted_2 = { "format-key": "0" }
const _hoisted_3 = {
  key: 0,
  class: "_flexcol _gap-3 _mt-3 _mb-6"
}
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = { class: "gfu-hd gfu-hd--h6 _fw-n" }
const _hoisted_6 = { class: "gfu-hd gfu-hd--h6 _fw-n" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_content_renderer = _resolveComponent("content-renderer")

  return (_ctx.isGpsrVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.GpsrInformationParagraph,
          class: "gfu-bt--caption",
          "data-qa": "productinfo:GpsrInfo"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.GpsrNameLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"]),
        (_ctx.isInformationsVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productGpsrInformation, ({ headerText, content, isRichText, dataQa }, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${index}-${headerText}`,
                  class: "gfu-bt--caption",
                  "data-qa": dataQa
                }, [
                  (!isRichText)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(headerText), 1 /* TEXT */),
                        _createElementVNode("div", null, _toDisplayString(content), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createBlock(_component_content_renderer, {
                        key: 1,
                        class: "gfu-bt--caption",
                        content: content
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(headerText), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content"]))
                ], 8 /* PROPS */, _hoisted_4))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}